import { AuthGuard } from './shared/auth.guard';
import { AboutComponent } from './pages/about/about.component';
import { AgreementComponent } from './pages/agreement/agreement.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { SigninPageComponent } from './account/signin-page/signin-page.component';
import { SignupPageComponent } from './account/signup-page/signup-page.component';
import { PasswordResetPageComponent } from './account/password-reset-page/password-reset-page.component';
import { PasswordFormPageComponent } from './account/password-form-page/password-form-page.component';
import { TermsComponent } from './pages/terms/terms.component';
import { ReleaseGuidelinesComponent } from './pages/release-guidelines/release-guidelines.component';
import { NoAuthGuard } from './shared/no-auth.guard';

const routes: Routes = [
  { path: 'login', component: SigninPageComponent, canActivate: [NoAuthGuard] },
  { path: 'login/:url', component: SigninPageComponent, canActivate: [NoAuthGuard] },
  { path: 'signup', component: SignupPageComponent, canActivate: [NoAuthGuard] },
  { path: 'signup/:url', component: SignupPageComponent, canActivate: [NoAuthGuard] },
  { path: 'passwd', component: PasswordResetPageComponent, canActivate: [NoAuthGuard] },
  { path: 'auth', component: PasswordFormPageComponent },
  { path: 'agreement', component: AgreementComponent },
  { path: 'terms', component: TermsComponent },
  { path: 'release-guidelines', component: ReleaseGuidelinesComponent },
  { path: 'about', component: AboutComponent },
  {
    path: 'mypage',
    loadChildren: './mypage/mypage.module#MypageModule',
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always'
  },
  { path: 'favorite', loadChildren: './favorite/favorite.module#FavoriteModule' },
  {
    path: 'profile',
    loadChildren: './profile/profile.module#ProfileModule',
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always'
  },
  { path: 'menu', loadChildren: './menu/menu.module#MenuModule' },
  { path: 'find', loadChildren: './find/find.module#FindModule' },
  { path: 'company', loadChildren: './company/company.module#CompanyModule' },
  { path: 'jobs', loadChildren: './jobs/jobs.module#JobsModule' },
  { path: 'story', loadChildren: './story/story.module#StoryModule' },
  {
    path: 'entry',
    loadChildren: './entry/entry.module#EntryModule',
    // canActivate: [AuthGuard],
    // runGuardsAndResolvers: 'always'
  },
  { path: 'feat', loadChildren: './feat/feat.module#FeatModule' },
  { path: 'business', loadChildren: './business/business.module#BusinessModule' },
  { path: 'vote',  loadChildren: './vote/vote.module#VoteModule'},
  { path: '', loadChildren: './home/home.module#HomeModule' },
  { path: 'no-internet', loadChildren: './no-internet/no-internet.module#NoInternetModule' },
  { path: '**', loadChildren: './not-found/not-found.module#NotFoundModule' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      scrollOffset: [0, 100],
      preloadingStrategy: PreloadAllModules
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
